/******************************************************************************
 *** BgtSpcDpstMng ** 특별회계기금 수입 결의서 관리 - 수입결의서 리스트
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";

interface Prpps {
    ognzCd: string;
    acntgYear: string;
    systemCode: string;
    searchAtrzSttsCd: string;
    setSpcAcntgDpstDocId: Function;
    callTime: Date;
}

const BgtSpcDpstMngList = ( {ognzCd, acntgYear, systemCode, searchAtrzSttsCd, setSpcAcntgDpstDocId, callTime}: Prpps) => {
    // 목록 데이터
    const [dataArr   , setDataArr   ] = React.useState<any[]>([]);
    const [sumDpstAmt, setSumDpstAmt] = React.useState<string>("0"); // 수입 합계

    // GridTable 컬럼
    const fldInfs: fldInfsProps[] = [
        { type: "date" , fldNm: "dpstDt"           , width: 100, headAlign: "center", dataAlign: "center", label: "수입일자" },
        { type: "text" , fldNm: "bgtSbjct3stNm"    , width: 100, headAlign: "center", dataAlign: "center", label: "목"       },
        { type: "text" , fldNm: "abstrCn"          , width: 150, headAlign: "center", dataAlign: "left"  , label: "적요"     },
        { type: "comma", fldNm: "dpstAmt"          , width: 100, headAlign: "center", dataAlign: "right" , label: "금액"     },
        { type: "el"   , fldNm: "atrzSttsNm"       , width: 100, headAlign: "center", dataAlign: "center", label: "진행상태",
            el: (item: any) => {
                return (
                    <span className={"ls06 " + (item.atrzSttsCd === "02" ? "fc007bff" : "")}>{item.atrzSttsNm}</span> // 작성완료 Text 색상 변경
                )
            }
        },
        { type: "text" , fldNm: "crtDt"            , width: 100, headAlign: "center", dataAlign: "center", label: "작성일시" },
        { type: "text" , fldNm: "dpstRsdocNo"      , width: 120, headAlign: "center", dataAlign: "center", label: "문서번호" },
    ];

    // 특별회계기금 수입결의서 작성 목록 조회  
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/spc/dpst/select-bgt-spc-dpst-list.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                orgCd         : ognzCd,      // 조직코드
                acntgYear     : acntgYear,   // 회계연도
                spcAcntgSeCd  : systemCode,  // 시스템ID
                searchAtrzSttsCd: searchAtrzSttsCd   // 진행상태
            },
            onSuccessFn: (res: any) => {
                setDataArr(res.result.list);
                setSumDpstAmt(res.result.listSum.sumDpstAmt); // 수입 합계금액
                AppContext.hideSpinner();
            },
        });
    }, [ognzCd, acntgYear, systemCode, searchAtrzSttsCd, setDataArr, setSumDpstAmt, callTime]);

    return (
        <div className="bd1d9d9d9 bdrd6 bgcWhite">
            <div className="pl15 pr15 pt5 pb15">
                <div className="dpFlx aiC jcSb mb10 h44">
                    <div className="fm-b fs16 fc007bff ls1 fw700">수입결의서 목록</div>
                </div>

                <div className="w100p ofxA ofyH bdt1 bdcEBEBEB pt6">
                    <div className="mw900">
                        <GridTable
                            tableInfo={{
                                tableHeadVsb: true,
                                styleType: AdminGridStyle,
                                fldInfs: fldInfs,
                                ordFld: { name: "depositDt", direction: "desc" },
                                dataArr: dataArr,
                                maxRowNums: [100, 200, 300],
                                theadTrHeight: 40,
                                tbodyTrHeight: 35,
                                paginateClass: "pt10",
                                paginateStyle: {
                                    buttonOnColor: AppContext.boardThemeColor,
                                    buttonWidth: 22, buttonHeight: 24,
                                    buttonMarginLeft: 1, buttonMarginRight: 1,
                                    fontSize: 13, color: "#666666", letterSpacing: -0.8, fontFamily: "Pretendard-Regular",
                                    borderRadius: 3,
                                },
                                // footerVsb: true,
                                rowClickFunc: (item: any) => {
                                    // row click
                                    setSpcAcntgDpstDocId(item.spcAcntgDpstDocId);
                                },
                            }}
                        />
                    </div>
                    <table className="w100p bgcDCDCDC">
                        <colgroup>
                            <col style={{width: "100px"}}></col>
                            <col style={{width: "100px"}}></col>
                            <col style={{width: "150px"}}></col>
                            <col style={{width: "100px"}}></col>
                            <col style={{width: "100px"}}></col>
                            <col style={{width: "100px"}}></col>
                            <col style={{width: "120px"}}></col>
                        </colgroup>
                        <tbody>
                            <tr style={{height: "35px"}}>
                                <td></td>
                                <td style={{textAlign: "center"}}><span className="fm-c fs15 ls06 fc2c3e50">합계</span></td>
                                <td colSpan={2} style={{textAlign: "right", paddingRight: "5px"}}>
                                    <span className="fs15 ls075">{Util.comma(sumDpstAmt)}</span>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default BgtSpcDpstMngList;